import 'core-js/stable';
import Vue from 'vue';
import VueMask from 'v-mask';

import App from './App';

Vue.config.performance = true;
Vue.use(VueMask);

new Vue({
	render: h => h(App)
}).$mount('#app');
